import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ReportLogService } from 'src/app/services/report-log.service';
import { TravelerService } from 'src/app/services/traveler.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-report-log-accounts',
  templateUrl: './report-log-accounts.component.html',
  styleUrls: ['./report-log-accounts.component.css']
})
export class ReportLogAccountsComponent implements OnInit {
  years = '';
  //tripId : number;
  title = "Log";
  showLog = true;
  accountData : any = {};

  yearList: any = [];
  tripOptionList = [];
  alltripList = [];
  tripId = '';
  searchText = '';
  customerId:string;

  // @Input() aYear:number;
  // @Input() aCustomerId : number;

  @Input() aYear!: string;
@Input() aCustomerId!: string;
  displayedColumn: string[] = [
      'logDate',
      'logTime',
      'logUser',
      'tripName',
      'groups',
      'travelerName',
      'changeType',
      'updateDetails'
    ];

  public accountsLogdata = new MatTableDataSource<AccountChangeLogModel>();

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  constructor(private _reportLogService :ReportLogService,
    private _utilityService : UtilityService,
    private travelerService : TravelerService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    // Try to get route params if they exist
  const yearParam = this.route.snapshot.paramMap.get('year');
  const customerParam = this.route.snapshot.paramMap.get('customerId');

  if (yearParam && customerParam) {
    this.aYear = yearParam;
    this.aCustomerId = customerParam;
  }

    this.years=this.aYear;
    this.customerId = this.aCustomerId;
    //this.tripId = 18;
    this.getAccountsLog();

    this.yearList = this._utilityService.fillYear(
      new Date().getFullYear() - 3,
      new Date().getFullYear() + 1
    );
    this.travelerService.getTripCodeList().subscribe((result) => {
      this.alltripList = result;
    });
  }
  ngAfterViewInit() {
    this.accountsLogdata.paginator = this.paginator;
    this.accountsLogdata.sort = this.sort;
  }
  Checklog()
  {
    if (this.showLog) {
      this.title = "Back";
    } else {
      this.title = "Log";
    }
    this.showLog = !this.showLog;
    this.getAccountsLog();
  }

  getAccountsLog()
  {
    this.accountData  = [];
    this._reportLogService.getAccountsLog(this.years,this.customerId)
    .subscribe((result : any) =>{
      this.accountData = this.accountsLogdata.data = result as AccountChangeLogModel[];
      this.accountsLogdata.paginator = this.paginator;
      //console.log(this.accountData,this.years);
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.searchText = filterValue;
    this.accountsLogdata.filter = filterValue;
  }
}

export interface AccountChangeLogModel {
  logDate: string;
  logTime: string;
  logUser: string;
  tripName: string;
  groups: string;
  travelerName: string;
  changeType: string;
  updateDetails: string;
}
